module.exports = __webpack_public_path__ + "img/menuCopyWhite.b4b7cae9.svg";